import {
  BETBY_BOTTOM_NAV_SELECTOR,
  BETBY_DESKTOP_BREAKPOINT_PX,
  BETBY_HEADER_OFFSET_PX,
  BETBY_HEADER_SELECTOR,
  BETBY_MOBILE_FOOTER_OFFSET_PX,
} from '@/constants/betby';

export interface BetbyLayoutOffsets {
  stickyTop: number;
  betSlipOffsetTop: number;
  betSlipOffsetBottom: number;
}

export const measureBetbyLayoutOffsets = (): BetbyLayoutOffsets => {
  const header = document.querySelector(BETBY_HEADER_SELECTOR);
  const bottomNav = document.querySelector(BETBY_BOTTOM_NAV_SELECTOR);
  const isDesktop = window.innerWidth >= BETBY_DESKTOP_BREAKPOINT_PX;

  const headerHeight = header instanceof HTMLElement
    ? Math.round(header.getBoundingClientRect().height)
    : BETBY_HEADER_OFFSET_PX;

  const bottomNavHeight = !isDesktop && bottomNav instanceof HTMLElement
    ? Math.round(bottomNav.getBoundingClientRect().height)
    : 0;

  const stickyTop = headerHeight > 0 ? headerHeight : BETBY_HEADER_OFFSET_PX;
  const betSlipOffsetBottom = isDesktop
    ? 0
    : (bottomNavHeight > 0 ? bottomNavHeight : BETBY_MOBILE_FOOTER_OFFSET_PX);

  return {
    stickyTop,
    betSlipOffsetTop: stickyTop,
    betSlipOffsetBottom,
  };
};
